import { ReferrerService } from './../../../../shared/services/referrer/referrer.service';
import { MessageService } from './../../../message/services/message/message.service';
import { ActivityService } from 'src/app/shared/services/activity/activity.service';
import { Component, Input, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/shared/services';
import { PageProgressService } from 'src/app/shared/services/page-progress-bar/page-progress.service';
import { MessageCodes, LanguageCodes } from 'src/app/shared/enums';
import { FeatureFlagService } from 'src/app/modules/feature-flags/services/feature-flag/feature-flag.service';
import { FeatureFlags } from 'src/app/shared/enums/feature-flags';
import { AudioDescriptor } from 'src/app/shared/enums/audio-descriptor';
import { AudioType } from 'src/app/shared/enums/audio-type';
import { ReadAloudService } from 'src/app/modules/read-aloud/services';
import { SceneService } from 'src/app/shared/services/scene/scene.service';
import { Subscription } from 'rxjs';
import { InboxDisplayStatus } from 'src/app/modules/student-inbox-api/enums/student-inbox.enums';

@Component({
  selector: 'htc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnDestroy {
  @Input() exitButtonText = 'Exit';
  @Input() exitButtonIcon = '/assets/button-icons/arrow.svg';
  @Input() showExitButton = true;
  @Input() showRewards = true;

  userMenuVisible = false;
  showSupportMenu = false;
  showSettingsMenu = false;
  isEarlyAccess = false;
  isAuthenticationEnabled = false;
  clickDescriptor = AudioDescriptor.SELECT_MAJOR_LO;
  clickType = AudioType.audio_SfxClick;
  disableHeaderButtons = false;
  private subscription = new Subscription();

  constructor(
    public userService: UserService,
    public pageProgressService: PageProgressService,
    public activityService: ActivityService,
    private featureFlagService: FeatureFlagService,
    private messageService: MessageService,
    private readAloudService: ReadAloudService,
    private referrerService: ReferrerService,
    private sceneService: SceneService
  ) {
    this.isEarlyAccess = this.featureFlagService.isFlagEnabled(
      FeatureFlags.EARLY_ACCESS
    );

    this.isAuthenticationEnabled = this.featureFlagService.isFlagEnabled(
      FeatureFlags.AUTHENTICATE
    );

    this.subscription.add(
      this.activityService.activitySubmitInProgress$.subscribe(isInProgress => {
        this.disableHeaderButtons = isInProgress;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onExitClick(): void {
    if (this.referrerService.isEducatorReferrer()) {
      this.readAloudService.stopCurrent();
      window.self.close();
    } else if (!this.activityService.quickExit) {
      const messageToShow =
        this.activityService.currActivity.language === LanguageCodes.SPANISH
          ? MessageCodes.APP_EXIT_ACTIVITY_CONFIRM_ES
          : MessageCodes.APP_EXIT_ACTIVITY_CONFIRM;
      this.messageService.showMessage(messageToShow, () => {
        this.readAloudService.stopCurrent();
        this.sceneService.interruptScene();
        this.navigateOnExit();
      });
    } else {
      this.readAloudService.stopCurrent();
      this.sceneService.interruptScene();
      this.activityService.exitActivity();
    }
  }

  navigateOnExit(): void {
    if (
      this.activityService.activityDisplayStatus !==
      InboxDisplayStatus.COMPLETED
    ) {
      this.activityService.updateDisplayStatus(InboxDisplayStatus.ABORTED); // Update display status to aborted before navigating away from actvitiy screen
    }
    if (
      this.featureFlagService.isFlagEnabled(FeatureFlags.RETURN_TO_REFERRER)
    ) {
      this.referrerService.navigateToReferrer();
    } else {
      this.activityService.exitActivity();
    }
  }

  toggleUserMenu(): void {
    this.userMenuVisible = !this.userMenuVisible;
  }
}
